import axios from 'axios';
import {history,} from '../store';
import setAuthorizationToken from '../utils/setAuthorizationToken';
import CommonConstants from '../utils/CommonConstants';
import { recordEvent } from '../utils/analyticsEvents';
const apiUrl = CommonConstants.Actions.api;
const rootUrl = CommonConstants.Actions.rootUrl;

export function signup(resendOTPData,email, password,password_confirmation, first_name, middle_name, last_name, gender,contact_number,birthdate,recaptcha,partnerCode){
  return function(dispatch)  {
    const attributes = (resendOTPData !== null) ? resendOTPData :
    ({
      'email' : email,
      'password' : password,
      'password_confirmation' : password_confirmation,
      'last_name' : last_name,
      'middle_name' : middle_name,
      'first_name' : first_name,
      'gender': gender,
      'phone_number' : contact_number,
      'birthdate': birthdate,
      'recaptcha':recaptcha,
      'pcode': partnerCode,
    })
    dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
    axios.post(rootUrl+'sign-up', {
        'data': {
          'type' : 'users',
          attributes
        }
    }).then((response) => {
      dispatch({type: 'SIGNUP_USER_FULFILLED', payload: response.data,})
      localStorage.setItem("otp_response", JSON.stringify(response.data))
      localStorage.setItem("otp_redirect", "signup");
      history.push('/otp-service')
    })
    .catch((err) =>{
      dispatch({type: 'SIGNUP_USER_REJECTED', payload: err})
    })
  }
}

export function sendOtp(payload, otpCode) {
  return function(dispatch){
    axios.post(rootUrl+'multifactor',{
      'data': {
        'type' : 'users_otp',
        'attributes' : {
          ...payload,
          otp_code: otpCode,
        }
      }
  }).then((response) => {
    const token = response.data.token;
    localStorage.setItem('jwtToken', token);
    localStorage.removeItem('otp_response');
    localStorage.removeItem('otp_redirect');
    setAuthorizationToken(token);
    dispatch({type: 'SEND_OTP_FULFILLED', payload: response.data,})
    recordEvent('sign_up_2019', 'Sign Up 2019', 'Completed', payload.email);
    history.push('/signup-success');
  })
    .catch((err) =>{
      recordEvent('sign_up_2019', 'Sign Up 2019', 'Failed', payload.email);
      dispatch({type: 'SEND_OTP_REJECTED', payload: err})
    })
  }
}

export function resetSignUp(){
  return function(dispatch){
      dispatch({type: 'RESET_SIGNUP',})
    }
}
export function getCopyrightYear(){
  return function(dispatch){
      axios.get(apiUrl+'year')
      .then((response) => {
        dispatch({type: 'GET_YEAR_FULFILLED', payload: response.data,})
      }).catch((err) =>{
        dispatch({type: 'GET_YEAR_REJECTED', payload: err,})
      })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/Signup.js
 **/